import React, { useState } from 'react';
import { CircleDollarSign, Users, TabletSmartphone, BarChart3, LifeBuoy, Rocket } from 'lucide-react';
import { Link } from 'react-router-dom';

function Cards({ cardData }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-4 mt-12">
      {cardData?.map((card, index) => (
        <div
          key={index}
          className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
        >
          <div className="p-4">
            <Link to={card.link} className="flex justify-between mb-1">
              {/* {card.icon} */}
              <div className="flex items-center gap-2">
                <img src={card.icon} alt="" className='h-8' />
                <h2 className="text-lg font-semibold">{card.title}</h2>
              </div>
            </Link>
            
            <div className="w-full mb-4" style={{ borderBottom: `4px solid ${card.color}` }}></div>
            <ul className="space-y-3 max-h-[250px] overflow-scroll p-2">
              {card.dataList.map((item, i) => (
                <li key={i} className="flex justify-between text-sm text-gray-700">
                  <span>{item.key}</span>
                  <span className="font-semibold">{item.value}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Cards;
